import Vue from 'vue'
// Lib imports
import axios from 'axios'
var production = true
Vue.prototype.$app_mode = "production"
var SERVER = "http://localhost:8100"
if(production) {
  if(Vue.prototype.$app_mode == "production")
      SERVER = "https://sel-srv.servehpbr.com"
  else if(Vue.prototype.$app_mode == "local")
        SERVER = "http://localhost:8100"
}
Vue.prototype.$http = axios.create({
  baseURL: SERVER + '/app/',
  headers: {
    Systemkey: 'ZURTjkfrNQYlRI0L5vM4aYZvnZEVqmTY5aDaJQ4fIut9QSM07RQXCRBc0JKM6FNxS9cmCXy3aaqXzqAEEfVJfGt448tKHsa3ntyQfJJT3iYECUESAdFGwEBXJevjMOuB'
  }
})
Vue.prototype.$fileserver = SERVER + '/public/'